export default __webpack_public_path__ + "9ea1f515c9c533f0c4d8ce67134a6c26.png";